import template from './contactsWithClientAccessList.template.html';

export default {
  template,
  bindings: {
    contacts: '=',
    onChange: '&',
    onReady: '&'
  },
controller: class controller {
    constructor($rootScope, $filter, $mdMedia, listService) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      var ctrl = this;
      ctrl.$mdMedia = $mdMedia;
      ctrl.natural = $rootScope.natural;
      ctrl.list = listService;
      ctrl.list.clear();

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      this.initialize = function () {
        ctrl.list.setData(
          $filter('stStartingLetter')(ctrl.contacts, ctrl.list.getGroupingByFirstLetter())
        );
        ctrl.onReady({ list: ctrl.list });
      };
      this.select = function (data) {
        var isSelected = ctrl.list.setSelected(data);
        ctrl.onChange({ list: ctrl.list, data: data, isSelected: isSelected });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = function () {
        ctrl.initialize();
      };
    }
  }
};
